module.exports = __webpack_public_path__ + "img/thumb_20.fedb1c30.jpg";